import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import { ItemList } from '../ItemList';
import Button from '../Button';
import FocusGroup from '../FocusGroup';
import Menu from '../Menu';
import Popover from '../Popover';
import { generateId } from '../utils';
import ComboboxInput from './ComboboxInput';

var ComboboxPopover = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ComboboxPopover, _Component);

  function ComboboxPopover() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isPopoverOpen: _this.props.defaultOpen || false
    });

    _defineProperty(_assertThisInitialized(_this), "id", generateId('combobox'));

    _defineProperty(_assertThisInitialized(_this), "inputNode", null);

    _defineProperty(_assertThisInitialized(_this), "inputTouched", false);

    _defineProperty(_assertThisInitialized(_this), "closeRequestId", null);

    _defineProperty(_assertThisInitialized(_this), "setItemListRef", function (component) {
      _this.itemList = component;
    });

    _defineProperty(_assertThisInitialized(_this), "setInputRef", function (component) {
      _this.input = component;
    });

    _defineProperty(_assertThisInitialized(_this), "openPopover", function () {
      _this.setState({
        isPopoverOpen: true
      }, function () {
        _this.itemList.setHighlightedIndex(0, {
          maybeScrollIntoView: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closePopover", function () {
      // push to next event stack because Popover events are messed up :(
      _this.closeRequestId = requestAnimationFrame(function () {
        _this.setState({
          isPopoverOpen: false
        }, function () {
          _this.itemList.clearHighlightedIndex();
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      _this.closePopover();

      _this.inputTouched = false;

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (event) {
      if (_this.props.closeOnSelect) {
        _this.closePopover();
      }

      if (_this.props.onSelect) {
        _this.props.onSelect(event);
      }
    });

    return _this;
  }

  var _proto = ComboboxPopover.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(lastProps) {
    if (lastProps.disabled !== lastProps.disabled && this.props.disabled === true) {
      this.closePopover();
    }

    var isComboboxFocused = document.activeElement === this.inputNode;

    if (isComboboxFocused && lastProps.value !== this.props.value && this.props.value.length > 0 && !this.state.isPopoverOpen) {
      this.openPopover();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.closeRequestId) {
      cancelAnimationFrame(this.closeRequestId);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        closeButton = _this$props.closeButton,
        closeOnSelect = _this$props.closeOnSelect,
        disabled = _this$props.disabled,
        dropdownButton = _this$props.dropdownButton,
        _innerRef = _this$props.innerRef,
        defaultOpen = _this$props.defaultOpen,
        lockScrollWhileOpen = _this$props.lockScrollWhileOpen,
        onClear = _this$props.onClear,
        onBlur = _this$props.onBlur,
        _onFocus = _this$props.onFocus,
        onSelect = _this$props.onSelect,
        openOnFocus = _this$props.openOnFocus,
        placement = _this$props.placement,
        popoverProps = _this$props.popoverProps,
        relativeTo = _this$props.relativeTo,
        renderTo = _this$props.renderTo,
        value = _this$props.value,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["children", "closeButton", "closeOnSelect", "disabled", "dropdownButton", "innerRef", "defaultOpen", "lockScrollWhileOpen", "onClear", "onBlur", "onFocus", "onSelect", "openOnFocus", "placement", "popoverProps", "relativeTo", "renderTo", "value"]);

    var isPopoverOpen = this.state.isPopoverOpen;
    var valuePresent = value && value.length > 0;
    return /*#__PURE__*/React.createElement(FocusGroup, {
      onBlur: this.handleBlur
    }, function (_ref) {
      var requestBlur = _ref.requestBlur,
          setRef = _ref.setRef;
      return /*#__PURE__*/React.createElement(ItemList, {
        ref: _this2.setItemListRef,
        onSelect: _this2.handleSelect
      }, function (_ref2) {
        var clearHighlightedIndex = _ref2.clearHighlightedIndex;
        return /*#__PURE__*/React.createElement(Popover, _extends({
          keepInView: false,
          matchWidths: true,
          minWidth: 16
        }, popoverProps, {
          as: Menu,
          ref: function ref(component) {
            _this2.popover = component;
          },
          innerRef: function innerRef(node) {
            setRef(_this2.id + "-popover")(node);
          },
          role: "menu",
          tabIndex: -1,
          elevation: 2,
          lockScrollWhileOpen: lockScrollWhileOpen,
          placement: placement,
          relativeTo: relativeTo,
          renderTo: renderTo,
          open: isPopoverOpen,
          onBlur: requestBlur,
          anchorElement: function anchorElement(anchorProps) {
            return /*#__PURE__*/React.createElement(ComboboxInput, _extends({
              ref: _this2.setInputRef,
              innerRef: function innerRef(node) {
                var _anchorProps$innerRef;

                if (typeof anchorProps.innerRef === 'function') {
                  anchorProps.innerRef(node);
                } else if ((_anchorProps$innerRef = anchorProps.innerRef) != null && _anchorProps$innerRef.current) {
                  anchorProps.innerRef.current = node;
                }

                _this2.inputNode = node ? node.querySelector('input') : null;
                setRef(_this2.id + "-input")(node);

                if (_innerRef) {
                  _innerRef(node);
                }
              },
              value: value,
              onFocus: function onFocus(event) {
                if (closeOnSelect ? openOnFocus && !_this2.inputTouched : openOnFocus) {
                  _this2.openPopover();
                }

                _this2.inputTouched = true;
                _onFocus && _onFocus(event);
              },
              onBlur: function onBlur(event) {
                requestBlur(event);
                clearHighlightedIndex();
              },
              onClear: valuePresent ? onClear : undefined,
              renderRight: closeButton ? /*#__PURE__*/React.createElement(Button, _extends({
                disabled: disabled,
                icon: {
                  name: 'close'
                },
                title: "close options",
                theme: false
              }, closeButton)) : dropdownButton ? /*#__PURE__*/React.createElement(Button, {
                disabled: disabled,
                icon: {
                  name: isPopoverOpen ? 'close' : 'arrow-down'
                },
                title: isPopoverOpen ? 'close options' : 'open options',
                theme: false,
                onClick: function onClick() {
                  if (isPopoverOpen) {
                    _this2.closePopover();
                  } else {
                    _this2.openPopover();
                  }

                  _this2.input.focus();
                }
              }) : null,
              disabled: disabled
            }, restProps));
          }
        }), children);
      });
    });
  };

  return ComboboxPopover;
}(Component);

_defineProperty(ComboboxPopover, "displayName", 'Combobox.Popover');

_defineProperty(ComboboxPopover, "defaultProps", {
  closeOnSelect: false,
  openOnFocus: false
});

export default ComboboxPopover;